// extracted by mini-css-extract-plugin
module.exports = {"noop":"Tabs_noop__1eB0j","tabs":"Tabs_tabs__P4Rwd","tabItem":"Tabs_tabItem__2zbBA","selected":"Tabs_selected__2QZcf","tabContent":"Tabs_tabContent__1OjJC"};